/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge3 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important; 
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id} delimiter-edge-12`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		> 
			<path fillRule="evenodd" clipRule="evenodd" enableBackground="new" fill={props.item.fill || "var(--force-contast-color)"}  d="M215.2,8c1.3,0,2.7,0,4,0c5.1,0.6,9.7,2.5,13.8,5.5c2.2,1.7,4.3,3.5,6.4,5.4c4,4.2,7.9,8.5,11.8,12.8
				c1.6,0.4,3.2,0.8,4.7,1.4c-3.5-3.8-5-8.3-4.6-13.5c0.7-4.2,3.1-6.8,7.2-7.9c1.2-0.3,2.5-0.5,3.7-0.5c-4.6,4.8-5.6,10.2-2.9,16.3
				c2.8,5.5,7.2,9.1,13.3,10.7c6.7,1.9,13.4,1.7,20.1-0.5c7.9-3.5,10.7-9.5,8.5-17.8c-1.9-4.5-5.2-7.5-9.9-8.9
				c-6.2-1.8-11.6-0.4-16.1,4.1c-2.5,3.1-3.3,6.6-2.2,10.4c1.3,2.6,3.4,4.3,6.1,5.2c3.7,1.3,6.9,0.7,9.7-1.9c1.9-2.4,1.7-4.7-0.4-6.9
				c-0.8-0.6-1.7-0.8-2.6-0.6c-0.2,0.1-0.4,0.2-0.5,0.4c0.2,0.6,0.5,1.1,0.8,1.7c0.4,2-0.4,3.3-2.4,4c-2.2,0.5-3.9-0.2-5.1-2.1
				c-0.6-3.8,1-6,4.9-6.6c3-0.4,5.6,0.5,7.7,2.7c1.9,3.5,1.5,6.8-1.3,9.7c-2.1,1.7-4.6,2.5-7.3,2.4c-4.1,0-7.5-1.4-10.3-4.4
				c-2.3-3.2-3-6.6-1.9-10.4c1.6-4.6,4.6-7.7,9.1-9.6c1.4-0.5,2.8-0.9,4.2-1.2c1.7,0,3.4,0,5.1,0c5.5,0.7,9.8,3.3,13.1,7.7
				c20.8,3.9,41.7,6.7,62.8,8.2c4.9,0.1,9.7,0.1,14.6,0.1c0.5-2.4,1.8-4,4-4.9c3.8-1.2,6.9-0.2,9.3,3c0.3,0.6,0.5,1.2,0.5,1.9
				c34.9,0,69.9,0,104.8,0c0,0.7,0,1.3,0,2c-34.9,0-69.9,0-104.8,0c-0.6,2.8-2.3,4.5-5.1,5.2c-3.9,0.7-6.7-0.7-8.5-4.1
				c-0.2-0.3-0.2-0.7-0.2-1.1c-9.4-0.3-18.7,0.1-28,1.2c-16.7,1.7-33.3,4-49.8,7.2c-3.3,3.8-7.4,6.1-12.4,7c-1.6,0.3-3.2,0.5-4.8,0.7
				c-2.7,0-5.5,0-8.2,0c-3.3-0.3-6.5-0.7-9.8-1.2c-5.2-1.1-10.5-2.2-15.7-3.1c-5-0.8-9.7,0-14.2,2.3c-0.4,0.3-0.9,0.7-1.3,1
				c-0.3-5,2-8.2,6.9-9.4c1.7-0.3,3.5-0.5,5.3-0.5c-3.8-4.2-7.8-8.4-11.8-12.4c-3.2-2.9-6.7-5.3-10.7-7c-5.9-2-11.7-1.8-17.4,0.6
				c-6.9,3.3-9.7,8.7-8.3,16.3c1.8,5.6,5.6,9.1,11.3,10.5c5,1.2,9.5,0.3,13.5-2.8c3.8-3.4,5.1-7.5,3.7-12.4c-0.7-1.2-1.5-2.2-2.6-3
				c-2.6-1.9-5.5-2.7-8.7-2.3c-2.1,0.4-3.8,1.6-5.1,3.3c-1.2,2.4-0.7,4.5,1.3,6.3c0.9,0.5,1.9,0.5,2.8,0.1c0-0.1,0.1-0.2,0.2-0.2
				c-1.3-1.8-1.2-3.4,0.3-5c1.9-1,3.7-0.9,5.4,0.3c1,1.1,1.4,2.3,1,3.8c-0.8,2.2-2.4,3.5-4.7,4c-3.5,0.5-6.3-0.6-8.5-3.3
				c-1.5-3.7-0.7-6.9,2.4-9.6c3.1-1.8,6.3-2.3,9.8-1.6c7.4,1.9,10.5,6.6,9.2,14.1c-1.4,4.7-4.4,8-9,9.9c-1.7,0.6-3.5,1.1-5.3,1.3
				c-1.1,0-2.2,0-3.3,0c-5.8-0.5-10.4-3-13.8-7.7c-20.7-3.9-41.5-6.7-62.5-8.2c-5.3-0.1-10.7-0.1-16-0.1c-0.6,2.6-2.1,4.3-4.7,5.1
				c-3.5,0.9-6.3,0-8.5-2.9c-0.4-0.7-0.7-1.4-0.9-2.1C71.6,26.1,36.8,26,1.9,26.1c0-0.7,0-1.3,0-2c34.9,0,69.8,0,104.7-0.1
				c1.1-3.5,3.4-5.2,7.1-5.4c2.7,0.1,4.8,1.2,6.2,3.4c0.3,0.6,0.6,1.3,0.7,2c9,0.3,18-0.1,26.9-1c17.3-1.7,34.5-4.1,51.6-7.3
				c2.8-3.2,6.2-5.4,10.3-6.5C211.3,8.7,213.3,8.3,215.2,8z"/>
		</svg>
	</div>
}

